export default __webpack_public_path__ + "media/images/backgrounds/snow_rain-7aeb0c4e5ead62bf95208abaac8a2f88.gif";